var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "detailsWrap",
      staticClass: "details_page_wrap",
      style: "height:" + _vm.wrapHeight + "px"
    },
    [
      _c("div", { staticClass: "details_page_title" }, [
        _c("h2", [
          _vm._v("《" + _vm._s(_vm.$route.query.paperName) + "》完成情况")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details_page_top" }, [
        _c("ul", [
          _c("li", [
            _c("img", {
              attrs: {
                src: require("../../../../../../static/images/study/testImg/detailsPage/tijiaorenshu.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c("h3", [_vm._v(_vm._s(_vm.submitSum) + "人")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("已提交人数（共" + _vm._s(_vm.totalSum) + "人）")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("img", {
              attrs: {
                src: require("../../../../../../static/images/study/testImg/detailsPage/pingjunfen.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c("h3", [_vm._v(_vm._s(_vm.averScore) + "分")]),
              _vm._v(" "),
              _c("p", [_vm._v("班级平均分")])
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("img", {
              attrs: {
                src: require("../../../../../../static/images/study/testImg/detailsPage/zuigaofen.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c("h3", [_vm._v(_vm._s(_vm.maxScore) + "分")]),
              _vm._v(" "),
              _c("p", [_vm._v("班级最高分")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details_page_bottom" }, [
        _c("div", { staticClass: "details_page_bottom_title" }, [
          _c(
            "ul",
            _vm._l(_vm.tabList, function(item, i) {
              return _c(
                "li",
                {
                  key: i,
                  class: { active: i === _vm.curIdx },
                  on: {
                    click: function($event) {
                      return _vm.tabSwitch(i)
                    }
                  }
                },
                [_c("p", [_vm._v(_vm._s(item))])]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.curIdx == 0
            ? _c(
                "div",
                { staticClass: "details_page_bottom_search" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.exportList()
                        }
                      }
                    },
                    [_vm._v("导出")]
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      "prefix-icon": "el-icon-search",
                      placeholder: "请输入学生姓名或学号",
                      clearable: ""
                    },
                    on: {
                      blur: function($event) {
                        return _vm.searchStudengName(_vm.studentName)
                      }
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchStudengName(_vm.studentName)
                      }
                    },
                    model: {
                      value: _vm.studentName,
                      callback: function($$v) {
                        _vm.studentName = $$v
                      },
                      expression: "studentName"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.search()
                        }
                      }
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.batchRecall(_vm.userIdsList)
                        }
                      }
                    },
                    [_vm._v("交卷撤回")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.batchRecallSubmissionPapers(
                            _vm.userIdsList
                          )
                        }
                      }
                    },
                    [_vm._v("强制交卷")]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.curIdx == 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingx,
                    expression: "loadingx"
                  }
                ],
                staticClass: "student_details_content"
              },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "student_details_table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "tooltip-effect": "dark",
                      height: _vm.wrapHeight - 280,
                      "row-key": "userId",
                      "header-cell-style": _vm.headerCellStyle,
                      "default-sort": { prop: "score", order: "descending" }
                    },
                    on: {
                      "sort-change": _vm.sortthiscolumn,
                      "selection-change": _vm.handleSelectionChange
                    }
                  },
                  [
                    _c("template", { slot: "empty" }, [
                      _c("div", { staticClass: "empty_data" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../../../../../static/images/wujieguo.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无数据")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "姓名" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "studentNo", label: "学号" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "status", label: "状态" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.status == 0
                                        ? "未提交"
                                        : "已提交"
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3664728831
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "score",
                        label: "得分",
                        sortable: "custom",
                        "sort-orders": ["ascending", "descending"]
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm.$route.query.markingWay == 1 &&
                                scope.row.status == 1
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            "批阅得分" +
                                              (scope.row.subjectiveScore || 0) +
                                              "、机器评分" +
                                              (scope.row.objectiveScore || 0) +
                                              "、总得分" +
                                              (scope.row.score || 0)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  : [
                                      scope.row.score
                                        ? _c("span", [
                                            _vm._v(_vm._s(scope.row.score))
                                          ])
                                        : scope.row.score == 0
                                        ? _c("span", [_vm._v("0")])
                                        : _c("span", [_vm._v("--")])
                                    ]
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2159363032
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { fixed: "right", label: "操作", width: "240" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm.noDemo
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { round: "", size: "small" },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.seeRow(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("查看")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.status == 1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { round: "", size: "small" },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.withdrawExam(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("撤回\n            ")]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        attrs: { round: "", size: "small" },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.submissionPapers(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("强制交卷\n            ")]
                                    )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        836285402
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.curIdx == 1
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "details_page_content"
              },
              [
                _c(
                  "ul",
                  { class: "question_type_tab " + _vm.fixedClass },
                  _vm._l(_vm.questionTypeList, function(item, i) {
                    return _c(
                      "li",
                      {
                        key: i,
                        class: { active: i === _vm.questionTypeIdx },
                        on: {
                          click: function($event) {
                            return _vm.questionTypeTabSwitch(i)
                          }
                        }
                      },
                      [
                        _c("p", [
                          _vm._v(_vm._s(item.sectionAlias || item.sectionName))
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._l(_vm.questionsDetail, function(item, key) {
                  return _vm.exmpData
                    ? _c(
                        "div",
                        {
                          key: key,
                          staticClass: "question_type radio",
                          attrs: { id: ["page" + key] }
                        },
                        [
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.chnNumCharStr(key)) +
                                "、" +
                                _vm._s(item.sectionName)
                            ),
                            _c("span", [
                              _vm._v("(" + _vm._s(item.sectionPrompt) + ")")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(item.questions, function(v, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "question_info" },
                              [
                                v.internalTypeId !== 6
                                  ? _c(
                                      "div",
                                      { staticClass: "question_false" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "question_info_left" },
                                          [
                                            v.internalTypeId !== 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "radio_subject"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(v.questionNum) +
                                                          "."
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass: "text",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          v.questionContent
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "radio_subject1"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(v.questionNum) +
                                                          "."
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          v.questionContent
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "radio_option"
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio-group",
                                                      {
                                                        model: {
                                                          value:
                                                            v.questionAnswer,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              v,
                                                              "questionAnswer",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "v.questionAnswer"
                                                        }
                                                      },
                                                      _vm._l(v.items, function(
                                                        k,
                                                        j
                                                      ) {
                                                        return _c(
                                                          "li",
                                                          { key: j },
                                                          [
                                                            _c(
                                                              "el-radio",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    k.itemKey,
                                                                  disabled:
                                                                    v.questionAnswer ==
                                                                    k.itemKey
                                                                      ? false
                                                                      : true
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      k.itemKey
                                                                    ) + "："
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("div", {
                                                                  staticClass:
                                                                    "radio_item",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      k.itemValue
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 2
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "radio_option"
                                                  },
                                                  [
                                                    _c(
                                                      "el-checkbox-group",
                                                      {
                                                        model: {
                                                          value: v.questionAnswer.split(
                                                            ","
                                                          ),
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              v.questionAnswer,
                                                              "split(',')",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "v.questionAnswer.split(',')"
                                                        }
                                                      },
                                                      _vm._l(v.items, function(
                                                        k,
                                                        j
                                                      ) {
                                                        return _c(
                                                          "li",
                                                          { key: j },
                                                          [
                                                            _c(
                                                              "el-checkbox",
                                                              {
                                                                attrs: {
                                                                  disabled: v.questionAnswer.includes(
                                                                    k.itemKey
                                                                  )
                                                                    ? false
                                                                    : true,
                                                                  label:
                                                                    k.itemKey
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      k.itemKey
                                                                    ) + "："
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("p", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      k.itemValue
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 3
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "radio_option"
                                                  },
                                                  [
                                                    _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "正确",
                                                              disabled:
                                                                v.questionAnswer ==
                                                                "错误"
                                                                  ? true
                                                                  : false
                                                            },
                                                            model: {
                                                              value:
                                                                v.questionAnswer,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  v,
                                                                  "questionAnswer",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "v.questionAnswer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.answerExchange(
                                                                  v.englishOption,
                                                                  "正确"
                                                                )
                                                              ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "错误",
                                                              disabled:
                                                                v.questionAnswer ==
                                                                "正确"
                                                                  ? true
                                                                  : false
                                                            },
                                                            model: {
                                                              value:
                                                                v.questionAnswer,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  v,
                                                                  "questionAnswer",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "v.questionAnswer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.answerExchange(
                                                                  v.englishOption,
                                                                  "错误"
                                                                )
                                                              ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 1 ||
                                            v.internalTypeId === 2 ||
                                            v.internalTypeId === 3
                                              ? _c(
                                                  "div",
                                                  { staticClass: "right_key" },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        "正确答案：" +
                                                          _vm._s(
                                                            _vm.answerExchange(
                                                              v.englishOption,
                                                              v.questionAnswer
                                                            )
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 4
                                              ? _c(
                                                  "div",
                                                  { staticClass: "right_key" },
                                                  [
                                                    _vm._v(
                                                      "\n                正确答案："
                                                    ),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          v.questionAnswer
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.flag && v.internalTypeId !== 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "topic_analysis",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          v
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v("打开解析"),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcDown
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !v.flag && v.internalTypeId !== 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "topic_analysis",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          v
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v("收起解析"),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcUp
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !v.flag && v.internalTypeId !== 9
                                              ? _c("span", {
                                                  staticClass: "analysis_cont",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      v.questionAnalysis
                                                        ? v.questionAnalysis
                                                        : "暂无解析"
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.flag && v.internalTypeId == 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "topic_analysis hands-on",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          v
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                打开答案"
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcDown
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !v.flag && v.internalTypeId == 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "topic_analysis hands-on",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          v
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                收起答案"
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcUp
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !v.flag && v.internalTypeId == 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "commentCont"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "comment1"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "comment2"
                                                      },
                                                      [
                                                        _c("my-component", {
                                                          attrs: {
                                                            isShow: "",
                                                            optObject:
                                                              _vm.optObject,
                                                            refresh:
                                                              _vm.refresh,
                                                            myId: v.questionId,
                                                            type: _vm.type,
                                                            preview: true,
                                                            companyCode:
                                                              _vm.companyCode
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass: "comment3"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "question_info_right"
                                          },
                                          [
                                            _c("h3", [_vm._v("正确率")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "circular_graph" },
                                              [
                                                _c("ve-ring", {
                                                  attrs: {
                                                    data: v.accuracys.chartData,
                                                    colors: v.accuracys.colors,
                                                    "tooltip-visible": false,
                                                    settings:
                                                      v.accuracys.settings,
                                                    legend: v.accuracys.legend,
                                                    width: "210px",
                                                    height: "190px",
                                                    extend:
                                                      v.accuracys.chartExtend,
                                                    title: v.accuracys.title
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    v.accuracys.chartData.rows,
                                                    function(val, i) {
                                                      return _c(
                                                        "li",
                                                        { key: i },
                                                        [
                                                          _c("i", {
                                                            style:
                                                              "background:" +
                                                              v.accuracys
                                                                .colors[i]
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                val.xuanxiang
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            v.internalTypeId === 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "question_info_number"
                                                  },
                                                  [
                                                    _c("ul", [
                                                      _c("li", [
                                                        _vm._v(
                                                          "答对：" +
                                                            _vm._s(
                                                              v.accuracys
                                                                .correctCount
                                                            ) +
                                                            "人"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("li", [
                                                        _vm._v(
                                                          "答错：" +
                                                            _vm._s(
                                                              v.accuracys
                                                                .errorCount
                                                            ) +
                                                            "人"
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        v.accuracys.chartData
                                                          .rows,
                                                        function(val, i) {
                                                          return _c(
                                                            "li",
                                                            { key: i },
                                                            [
                                                              _vm._v(
                                                                "选" +
                                                                  _vm._s(
                                                                    val.xuanxiang
                                                                  ) +
                                                                  "：" +
                                                                  _vm._s(
                                                                    val.renshu
                                                                  ) +
                                                                  "人"
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 2 ||
                                            v.internalTypeId === 3
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "question_info_number otherType"
                                                  },
                                                  [
                                                    _c("ul", [
                                                      _c("li", [
                                                        _vm._v(
                                                          "答对：" +
                                                            _vm._s(
                                                              v.accuracys
                                                                .correctCount
                                                            ) +
                                                            "人"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("li", [
                                                        _vm._v(
                                                          "答错：" +
                                                            _vm._s(
                                                              v.accuracys
                                                                .errorCount
                                                            ) +
                                                            "人"
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            v.internalTypeId === 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "question_info_number otherType operation"
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        v.accuracys.chartData
                                                          .rows,
                                                        function(val, i) {
                                                          return _c(
                                                            "li",
                                                            { key: i },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    val.xuanxiang
                                                                  ) +
                                                                    "：" +
                                                                    _vm._s(
                                                                      val.renshu
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                v.internalTypeId === 6
                                  ? _c(
                                      "div",
                                      { staticClass: "zuhe" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "question_content" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text_index1" },
                                              [
                                                _vm._v(
                                                  "阅读以下内容，回答第" +
                                                    _vm._s(v.questionNum) +
                                                    "-" +
                                                    _vm._s(
                                                      v.questionNum +
                                                        v.childQuestionArr
                                                          .length -
                                                        1
                                                    ) +
                                                    "题"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", {
                                              staticClass: "text",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  v.questionContent
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(v.childQuestionArr, function(
                                          a,
                                          b
                                        ) {
                                          return _c(
                                            "div",
                                            { key: b, staticClass: "zuheti" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "question_info_left"
                                                },
                                                [
                                                  a.internalTypeId !== 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "radio_subject"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                a.questionNum -
                                                                  1
                                                              ) + "."
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                a.questionContent
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "radio_subject1"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                a.questionNum -
                                                                  1
                                                              ) + "."
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                a.questionContent
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "radio_option"
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio-group",
                                                            {
                                                              model: {
                                                                value:
                                                                  a.questionAnswer,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    a,
                                                                    "questionAnswer",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "a.questionAnswer"
                                                              }
                                                            },
                                                            _vm._l(
                                                              a.items,
                                                              function(k, j) {
                                                                return _c(
                                                                  "li",
                                                                  [
                                                                    _c(
                                                                      "el-radio",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            k.itemKey,
                                                                          disabled:
                                                                            a.questionAnswer ==
                                                                            k.itemKey
                                                                              ? false
                                                                              : true
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                k.itemKey
                                                                              ) +
                                                                                "："
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "radio_item",
                                                                            domProps: {
                                                                              innerHTML: _vm._s(
                                                                                k.itemValue
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 2
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "radio_option"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox-group",
                                                            {
                                                              model: {
                                                                value: a.questionAnswer.split(
                                                                  ","
                                                                ),
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    a.questionAnswer,
                                                                    "split(',')",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "a.questionAnswer.split(',')"
                                                              }
                                                            },
                                                            _vm._l(
                                                              a.items,
                                                              function(k, j) {
                                                                return _c(
                                                                  "li",
                                                                  [
                                                                    _c(
                                                                      "el-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          disabled: a.questionAnswer.includes(
                                                                            k.itemKey
                                                                          )
                                                                            ? false
                                                                            : true,
                                                                          label:
                                                                            k.itemKey
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                k.itemKey
                                                                              ) +
                                                                                "："
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            domProps: {
                                                                              innerHTML: _vm._s(
                                                                                k.itemValue
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 3
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "radio_option"
                                                        },
                                                        [
                                                          _c(
                                                            "li",
                                                            [
                                                              _c(
                                                                "el-radio",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "正确",
                                                                    disabled:
                                                                      a.questionAnswer ==
                                                                      "错误"
                                                                        ? true
                                                                        : false
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      a.questionAnswer,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        a,
                                                                        "questionAnswer",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "a.questionAnswer"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.answerExchange(
                                                                        a.englishOption,
                                                                        "正确"
                                                                      )
                                                                    ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            [
                                                              _c(
                                                                "el-radio",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "错误",
                                                                    disabled:
                                                                      a.questionAnswer ==
                                                                      "正确"
                                                                        ? true
                                                                        : false
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      a.questionAnswer,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        a,
                                                                        "questionAnswer",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "a.questionAnswer"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.answerExchange(
                                                                        a.englishOption,
                                                                        "错误"
                                                                      )
                                                                    ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 1 ||
                                                  a.internalTypeId === 2 ||
                                                  a.internalTypeId === 3
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "right_key"
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v(
                                                              "正确答案：" +
                                                                _vm._s(
                                                                  _vm.answerExchange(
                                                                    a.englishOption,
                                                                    a.questionAnswer
                                                                  )
                                                                )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 4
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "right_key"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  正确答案："
                                                          ),
                                                          _c("p", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                a.questionAnswer
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.flag &&
                                                  a.internalTypeId !== 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "topic_analysis",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openAnalysis(
                                                                a
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v("打开解析"),
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                _vm.imgSrcDown
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !a.flag &&
                                                  a.internalTypeId !== 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "topic_analysis",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openAnalysis(
                                                                a
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v("收起解析"),
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.imgSrcUp
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !a.flag &&
                                                  a.internalTypeId !== 9
                                                    ? _c("span", {
                                                        staticClass:
                                                          "analysis_cont",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            a.questionAnalysis
                                                              ? a.questionAnalysis
                                                              : "暂无解析"
                                                          )
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.flag &&
                                                  a.internalTypeId == 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "topic_analysis hands-on",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openAnalysis(
                                                                a
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  打开答案"
                                                          ),
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                _vm.imgSrcDown
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !a.flag &&
                                                  a.internalTypeId == 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "topic_analysis hands-on",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openAnalysis(
                                                                a
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  收起答案"
                                                          ),
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.imgSrcUp
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !a.flag &&
                                                  a.internalTypeId == 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "commentCont"
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "comment1"
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "comment2"
                                                            },
                                                            [
                                                              _c(
                                                                "my-component",
                                                                {
                                                                  attrs: {
                                                                    isShow: "",
                                                                    optObject:
                                                                      _vm.optObject,
                                                                    refresh:
                                                                      _vm.refresh,
                                                                    myId:
                                                                      a.questionId,
                                                                    type:
                                                                      _vm.type,
                                                                    preview: true,
                                                                    companyCode:
                                                                      _vm.companyCode
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "comment3"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "question_info_right"
                                                },
                                                [
                                                  _c("h3", [_vm._v("正确率")]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "circular_graph"
                                                    },
                                                    [
                                                      _c("ve-ring", {
                                                        attrs: {
                                                          data:
                                                            a.accuracys
                                                              .chartData,
                                                          colors:
                                                            a.accuracys.colors,
                                                          "tooltip-visible": false,
                                                          settings:
                                                            a.accuracys
                                                              .settings,
                                                          legend:
                                                            a.accuracys.legend,
                                                          width: "210px",
                                                          height: "190px",
                                                          extend:
                                                            a.accuracys
                                                              .chartExtend,
                                                          title:
                                                            a.accuracys.title
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "ul",
                                                        _vm._l(
                                                          a.accuracys.chartData
                                                            .rows,
                                                          function(val, i) {
                                                            return _c(
                                                              "li",
                                                              { key: i },
                                                              [
                                                                _c("i", {
                                                                  style:
                                                                    "background:" +
                                                                    a.accuracys
                                                                      .colors[i]
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      val.xuanxiang
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "question_info_number"
                                                        },
                                                        [
                                                          _c("ul", [
                                                            _c("li", [
                                                              _vm._v(
                                                                "答对：" +
                                                                  _vm._s(
                                                                    a.accuracys
                                                                      .correctCount
                                                                  ) +
                                                                  "人"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("li", [
                                                              _vm._v(
                                                                "答错：" +
                                                                  _vm._s(
                                                                    a.accuracys
                                                                      .errorCount
                                                                  ) +
                                                                  "人"
                                                              )
                                                            ])
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ul",
                                                            _vm._l(
                                                              a.accuracys
                                                                .chartData.rows,
                                                              function(val, i) {
                                                                return _c(
                                                                  "li",
                                                                  { key: i },
                                                                  [
                                                                    _vm._v(
                                                                      "选" +
                                                                        _vm._s(
                                                                          val.xuanxiang
                                                                        ) +
                                                                        "：" +
                                                                        _vm._s(
                                                                          val.renshu
                                                                        ) +
                                                                        "人"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 2 ||
                                                  a.internalTypeId === 3
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "question_info_number otherType"
                                                        },
                                                        [
                                                          _c("ul", [
                                                            _c("li", [
                                                              _vm._v(
                                                                "答对：" +
                                                                  _vm._s(
                                                                    a.accuracys
                                                                      .correctCount
                                                                  ) +
                                                                  "人"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("li", [
                                                              _vm._v(
                                                                "答错：" +
                                                                  _vm._s(
                                                                    a.accuracys
                                                                      .errorCount
                                                                  ) +
                                                                  "人"
                                                              )
                                                            ])
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  a.internalTypeId === 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "question_info_number otherType operation"
                                                        },
                                                        [
                                                          _c(
                                                            "ul",
                                                            _vm._l(
                                                              a.accuracys
                                                                .chartData.rows,
                                                              function(val, i) {
                                                                return _c(
                                                                  "li",
                                                                  { key: i },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          val.xuanxiang
                                                                        ) +
                                                                          "：" +
                                                                          _vm._s(
                                                                            val.renshu
                                                                          )
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                !_vm.exmpData
                  ? _c("div", { staticClass: "question_exmp" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../../../../static/images/wujieguo.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("学生暂未提交，无法查看")])
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f2452ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f2452ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testing/detailsPage.vue
// module id = null
// module chunks = 